import { Checkbox, Stack, TextField } from '@atgfr8/atg-ui-tailwind';
import { BasicModal } from '@components';
import { createAppStore } from '@store/createAppStore';
import { closeModal } from '@store/modals';
import { saveOrderTemplate } from '@store/orders';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';

type TemplateInfoType = {
  name: string;
  public: boolean;
  nameError: string;
};

export const saveAsTemplateModalId = 'saveAsTemplateModal';

export const SaveAsTemplateModal = () => {
  const [templateInfo, setTemplateInfo] = createAppStore<TemplateInfoType>(
    {
      name: '',
      public: true,
      nameError: '',
    },
    'saveAsTemplateTemplateInfo',
    true,
  );

  const resetState = () => {
    setTemplateInfo({
      name: '',
      public: true,
      nameError: '',
    });
  };

  const handleSubmit = async () => {
    const name = templateInfo.name.trim();

    if (name.length === 0) {
      setTemplateInfo('nameError', 'Template name is required');
      return;
    }

    await saveOrderTemplate(
      name,
      templateInfo.public,
      undefined,
      CHANGE_TRACKING_SOURCES.orderDetails.orderHeaderSaveTemplate,
    );
    resetState();
    closeModal(saveAsTemplateModalId);
  };

  const handletemplateNameChange = (val: string) => {
    if (val.length > 0 && templateInfo.nameError.length > 0) {
      setTemplateInfo('nameError', '');
    }

    setTemplateInfo('name', val);
  };

  return (
    <BasicModal
      id={saveAsTemplateModalId}
      title="Save New Template"
      width={'450px'}
      onClose={() => {
        resetState();
        closeModal(saveAsTemplateModalId);
      }}
      onSubmitText={'Save'}
      footer={true}
      onSubmit={handleSubmit}
      preventCloseOnSubmit
    >
      <Stack spacing={2}>
        <TextField
          label="Template Name"
          placeholder="Enter template name"
          fullWidth
          value={templateInfo.name}
          required
          onChange={(val: string) => handletemplateNameChange(val)}
          error={templateInfo.nameError}
          dataTestId={'template-name-textInput'}
        />
        <Checkbox
          label="Public (everyone in my office can use this template for their loads)"
          checked={templateInfo.public}
          onChange={(val) => setTemplateInfo('public', val as boolean)}
          dataTestId={'public-checkboxInput'}
          size="xs"
          color="info"
          class="ml-[-9px] [&>span]:font-bold"
        />
      </Stack>
    </BasicModal>
  );
};
